<div class="grid" *ngIf="loading">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{ 'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<ng-container *ngIf="!loading">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="!isDetail" novalidate id="fFormularioProductoMontos" name="nomFormularioProductoMontos">
    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'PRODUCTO.LBL_INICIO_RANGO_MONTO' | translate }}</label>
          <div>
            <input
              pInputText
              type="text"
              autocomplete="off"
              id="rangoInicial"
              name="rangoInicial"
              formControlName="rangoInicial"
              [maxlength]="15"
              currencyMask
              [options]="currencyMaskOptions">
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoInicial.errors?.required">
              {{ 'PRODUCTO.LBL_INICIO_RANGO_MONTO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.rangoInicial.errors?.required && form.errors?.rangeSequence">
              {{ 'PRODUCTO.LBL_INICIO_RANGO_MONTO' | translate }} {{ 'PRODUCTO.LBL_MENOR_A' | translate }} {{ 'PRODUCTO.LBL_FIN_RANGO_MONTO' | translate }}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.rangoInicial.errors?.required && !form.errors?.rangeSequence && form.errors?.rangeOverlap">
              {{ 'PRODUCTO.LBL_ERROR_RANGOS' | translate }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'PRODUCTO.LBL_FIN_RANGO_MONTO' | translate }}</label>
          <div>
            <input
              pInputText
              type="text"
              autocomplete="off"
              id="rangoFinal"
              name="rangoFinal"
              formControlName="rangoFinal"
              [maxlength]="15"
              currencyMask
              [options]="currencyMaskOptions">
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoFinal.errors?.required">
              {{ 'PRODUCTO.LBL_FIN_RANGO_MONTO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.rangoFinal.errors?.required && form.errors?.rangeSequence">
              {{ 'PRODUCTO.LBL_FIN_RANGO_MONTO' | translate }} {{ 'PRODUCTO.LBL_MAYOR_A' | translate }} {{ 'PRODUCTO.LBL_INICIO_RANGO_MONTO' | translate }}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.rangoFinal.errors?.required && !form.errors?.rangeSequence && form.errors?.rangeOverlap">
              {{ 'PRODUCTO.LBL_ERROR_RANGOS' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!saving">
          <a (click)="onCancel()" class="cancelar">{{ 'BTN_CANCELAR' | translate }}</a>
          <button icon="fa fa-plus"
                  label="{{( f.idProductoMontoInversion.value ? 'BTN_ACTUALIZAR' : 'BTN_AGREGAR')  | translate }}"
                  type="submit"
                  pButton>
          </button>
        </div>
        <div *ngIf="saving">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{ 'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="cols"
               [rows]="10"
               [loading]="saving"
               [value]="productoMontosInversion"
               [paginator]="true"
               selectionMode="single"
               dataKey="idProductoMontoInversion"
               paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{ row.rangoInicial | dinero:0 }}</td>
            <td>{{ row.rangoFinal | dinero:0 }}</td>
            <td class="text-center" *ngIf="!isDetail">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_INHABILITAR' | translate}}" pButton (click)="onDelete(row)">
                </button>
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton (click)="onEdit(row)">
                </button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</ng-container>

<p-confirmDialog #cd key="producto-montos-inversion">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
